export default __webpack_public_path__ + "static/media/travel.77a22389.svg";